import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["type", "id"]
const _hoisted_3 = ["type", "id"]
const _hoisted_4 = {
  key: 0,
  class: "fa-solid fa-check"
}
const _hoisted_5 = {
  key: 1,
  class: "fa-solid fa-xmark"
}

import {  onMounted, ref, watch, watchEffect } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  placeholder: String,
  id: String,
  type: String,
  helperMsg: Array,
  value: { type: String, default: '' },
  rules: Array
},
  emits: ['update:error','update:modelValue',],
  setup(__props, { emit }) {

const props = __props





//DATA
const error = ref(false);
const modelValue = ref('');

const validate = (value : string) => {
  if (props.rules) {
    props.rules.forEach((rule: any) => {
      if (!new RegExp(rule.regexp).test(value)) {
        error.value = true;
        rule.isValid = false;
      } else {
        error.value = false;
        rule.isValid = true;
      }
    })
  }
};

watch(modelValue, () => {
  validate(modelValue.value);
});

watch(error, () => {
  emit('update:error', error.value);
});

onMounted(() => {
  if (props.value) modelValue.value = props.value;
  validate(modelValue.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['sqg-input', {'-fill': modelValue.value !== ''}, {'-error': error.value}])
  }, [
    _createElementVNode("label", { for: __props.id }, _toDisplayString(__props.placeholder), 9, _hoisted_1),
    (__props.type !== 'date')
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          type: __props.type,
          id: __props.id,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', modelValue.value)))
        }, null, 40, _hoisted_2)), [
          [_vModelDynamic, modelValue.value]
        ])
      : _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 1,
          type: __props.type,
          id: __props.id,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modelValue).value = $event)),
          onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:modelValue', modelValue.value)))
        }, null, 40, _hoisted_3)), [
          [_vModelDynamic, modelValue.value]
        ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rules, (rule, index) => {
      return (_openBlock(), _createElementBlock("span", {
        key: index,
        class: _normalizeClass(['sqg-input__helper', {'-valid' : rule.isValid}])
      }, [
        (rule.isValid)
          ? (_openBlock(), _createElementBlock("i", _hoisted_4))
          : (_openBlock(), _createElementBlock("i", _hoisted_5)),
        _createTextVNode(_toDisplayString(rule.msg), 1)
      ], 2))
    }), 128))
  ], 2))
}
}

})